/**
 * --------------------------------------------------
 * Module to show and hide stuff
 *
 * @module Visible
 * --------------------------------------------------
 */

export default {
    _$elemTrigger: null,

    setup: function () {

        // Get elements with trigger class
        this._$elemTrigger = $('.rt-js-trigger');

        // If no trigger elements, exit
        if (this._$elemTrigger.length === 0) return;

        // Target all elements in DOM
        this._$elemTrigger.each((index, elem) => {

            // Get the trigger element and its target
            const $elem = $(elem);
            const targetClass = $elem.data('target');
            const elemTarget = targetClass ? '.' + targetClass : '.rt-js-target';

            // Add click event listener to trigger element
            $elem.on('click', function (e) {
                e.preventDefault();

                // Some variables to use for toggling
                const $elem = $(e.currentTarget);
                const hiddenClass = $elem.data('hidden-class') || 'hidden';
                const $target = $elem.parent().find(elemTarget);

                // Toggle the target element and open state on the button
                $target.toggleClass(hiddenClass);
                $elem.toggleClass('is-open');
            });
        });
    }
}